export default __webpack_public_path__ + "static/premium-banner-img-desktop-0b711ba90ce50492e76ea3207bea19a1.png";